import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { ActionButton } from "models/propTypes/commonPropTypes";
import { TranslationKeys } from "translations";
import { MonthlyViewFooterProps } from "models/propTypes/timeReportingPropTypes";
import { WintSuperkollAPIModelTimeReporting } from "wint-api-client/dist/types";
//#endregion
//#region components
import { PageFooter } from "components/common";
import { useTimeReportingService } from "serviceHooks";
import useTimeReportingEventHandlers from "../forms/useTimeReportingEventHandlers";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const MonthlyViewFooter: React.FC<MonthlyViewFooterProps> = (props) => {
  const timeReportingService = useTimeReportingService();
  const { employeeId, reloadHandler, monthStatus, dateRange } = props;

  const changeMonthStatus = async (lock: boolean) => {
    if (dateRange?.start && dateRange?.end) {
      const model: WintSuperkollAPIModelTimeReporting.UpdateStatusByDateRange = {
        employeeId: employeeId,
        startDate: dateRange?.start,
        endDate: dateRange.end,
        status: lock
          ? WintSuperkollAPIModelTimeReporting.TimeReportStatus.Locked
          : WintSuperkollAPIModelTimeReporting.TimeReportStatus.Open,
      };

      return timeReportingService.updateStatus(model);
    }
  };

  const { onLockMonthClick } = useTimeReportingEventHandlers(changeMonthStatus.bind(null, true), reloadHandler);

  const onUnLockMonthClick = async () => {
    await changeMonthStatus(false);
    reloadHandler && reloadHandler();
  };

  const lockMonthAction = {
    text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.LockMonth),
    onClick: onLockMonthClick.bind(null, employeeId, dateRange?.start),
    type: StyleEnums.DisplayType.Success,
    isDisabled: !props.isValid,
  };

  const unLockMonthAction = {
    text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.UnLockMonth),
    onClick: onUnLockMonthClick,
    type: StyleEnums.DisplayType.Success,
    isDisabled: !props.isValid || !timeReportingService.canLoggedInUserChangeStatus(monthStatus),
  };

  const getActions = React.useMemo(() => {
    const actions: ActionButton[] = [];

    const displayLock = timeReportingService.getDisplayLockStatus(monthStatus);

    if (displayLock) {
      actions.push(lockMonthAction);
    } else {
      actions.push(unLockMonthAction);
    }

    return actions;
  }, [monthStatus, props.isValid]);

  return <PageFooter actions={getActions} />;
};

export default MonthlyViewFooter;
